import { render, staticRenderFns } from "./MailSettingsTestMail.vue?vue&type=template&id=6a8fb21e&"
import script from "./MailSettingsTestMail.vue?vue&type=script&lang=js&"
export * from "./MailSettingsTestMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports